import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import dashboardService from "../../services/DashboardService";
import Cookies from "js-cookie";

export const initialState = {
    loading_jumlah_pegawai_per_pengawas: false,
    data_jumlah_pegawai_per_pengawas: [],
    loading_persentase_pegawai_cek_presensi:false,
    data_persentase_pegawai_cek_presensi:[],
    loading_persentase_kehadiran_pegawai:false,
    data_persentase_kehadiran_pegawai:[],
    loading_pengawas_belum_pengajuan:false,
    data_pengawas_belum_pengajuan:[],
    loading_project_belum_pengajuan:false,
    data_project_belum_pengajuan:[],
    showMessage:false,
    message:'',
}


export const getDataJumlahPegawaiPerPengawas = createAsyncThunk('dashboard/data_jumlah_pegawai_per_pengawas',async (data, { rejectWithValue }) => {
    try {
        const response = await dashboardService.jumlah_pegawai_per_pengawas(data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPersentasePegawaiCekPresensi = createAsyncThunk('dashboard/persentase_pegawai_cek_presensi',async (data, { rejectWithValue }) => {
    try {
        const response = await dashboardService.persentase_pegawai_cek_presensi(data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPersentaseKehadiranPegawai = createAsyncThunk('dashboard/persentase_kehadiran_pegawai',async (data, { rejectWithValue }) => {
    try {
        const response = await dashboardService.persentase_kehadiran_pegawai(data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPengawasBelumPengajuan = createAsyncThunk('dashboard/pengawas_belum_pengajuan',async (data, { rejectWithValue }) => {
    try {
        const response = await dashboardService.pengawas_belum_pengajuan(data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataProjectBelumPengajuan = createAsyncThunk('dashboard/project_belum_pengajuan',async (data, { rejectWithValue }) => {
    try {
        const response = await dashboardService.project_belum_pengajuan(data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_jumlah_pegawai_per_pengawas = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataJumlahPegawaiPerPengawas.fulfilled, (state, action) => {
                state.loading_jumlah_pegawai_per_pengawas = false
                state.data_jumlah_pegawai_per_pengawas = action.payload??[]
            })
            .addCase(getDataJumlahPegawaiPerPengawas.pending, (state) => {
                state.loading_jumlah_pegawai_per_pengawas = true
            })
            .addCase(getDataJumlahPegawaiPerPengawas.rejected, (state, action) => {
                state.loading_jumlah_pegawai_per_pengawas = false
                state.data_jumlah_pegawai_per_pengawas = action.payload??[]
            })
            .addCase(getDataPersentasePegawaiCekPresensi.fulfilled, (state, action) => {
                state.loading_persentase_pegawai_cek_presensi = false
                state.data_persentase_pegawai_cek_presensi = action.payload??[]
            })
            .addCase(getDataPersentasePegawaiCekPresensi.pending, (state) => {
                state.loading_persentase_pegawai_cek_presensi = true
            })
            .addCase(getDataPersentasePegawaiCekPresensi.rejected, (state, action) => {
                state.loading_persentase_pegawai_cek_presensi = false
                state.data_persentase_pegawai_cek_presensi = action.payload??[]
            })
            .addCase(getDataPersentaseKehadiranPegawai.fulfilled, (state, action) => {
                state.loading_persentase_kehadiran_pegawai = false
                state.data_persentase_kehadiran_pegawai = action.payload??[]
            })
            .addCase(getDataPersentaseKehadiranPegawai.pending, (state) => {
                state.loading_persentase_kehadiran_pegawai = true
            })
            .addCase(getDataPersentaseKehadiranPegawai.rejected, (state, action) => {
                state.loading_persentase_kehadiran_pegawai = false
                state.data_persentase_kehadiran_pegawai = action.payload??[]
            })
            .addCase(getDataPengawasBelumPengajuan.fulfilled, (state, action) => {
                state.loading_pengawas_belum_pengajuan = false
                state.data_pengawas_belum_pengajuan = action.payload??[]
            })
            .addCase(getDataPengawasBelumPengajuan.pending, (state) => {
                state.loading_pengawas_belum_pengajuan = true
            })
            .addCase(getDataPengawasBelumPengajuan.rejected, (state, action) => {
                state.loading_pengawas_belum_pengajuan = false
                state.data_pengawas_belum_pengajuan = action.payload??[]
            })
            .addCase(getDataProjectBelumPengajuan.fulfilled, (state, action) => {
                state.loading_project_belum_pengajuan = false
                state.data_project_belum_pengajuan = action.payload??[]
            })
            .addCase(getDataProjectBelumPengajuan.pending, (state) => {
                state.loading_project_belum_pengajuan = true
            })
            .addCase(getDataProjectBelumPengajuan.rejected, (state, action) => {
                state.loading_project_belum_pengajuan = false
                state.data_project_belum_pengajuan = action.payload??[]
            })
    },
})

export const {
    showLoading,
} = dashboardSlice.actions

export default dashboardSlice.reducer
